import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-control_telephone",
  "use": "icon-control_telephone-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-control_telephone\">\n  <g transform=\"translate(3 1)\">\n    <rect stroke=\"currentColor\" fill=\"transparent\" x=\".5\" y=\".5\" width=\"9\" height=\"13\" rx=\"2\" />\n    <path d=\"M.588 8.522H10v1H.588z\" />\n    <circle cx=\"5\" cy=\"11.261\" r=\"1\" />\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol